import React from "react";

// Styles
import Styles from "./ExpiryPill.module.scss";
import classNames from "classnames";

// Helpers
import { getTimeDiffMs } from "@vahak/core/dist/methods/getTimeDiffMs";
import { getTimeDiffString } from "@vahak/core/dist/methods/getTimeDiffString";

// Constants
import { expiryPriority } from "../../constants";

interface expiryPillProps {
    expiry_time: string;
    is_mobile?: boolean;
    expiresClass?: string;
    expiration_hour?: string;
}

const expiryPill = ({ expiresClass, expiry_time, is_mobile = false, expiration_hour }: expiryPillProps) => {
    const renderTime = (expiry_time: string) => {
        const time = getTimeDiffString(new Date().toISOString(), expiry_time);
        if (parseInt(time) > 0 || (expiration_hour && parseInt(expiration_hour) > 0)) {
            const timeExpires = getTimeDiffMs(new Date().toISOString(), expiry_time);
            const expirationHours = expiration_hour ? parseInt(expiration_hour) : 0;
            const hours = Math.floor(timeExpires / (1000 * 60 * 60)) || expirationHours;
            const expirationTime = parseInt(time) > 0 ? time : expiration_hour;
            if (hours < 2)
                return {
                    text: `Expires in ${expirationTime}`,
                    styleObj: expiryPriority.most
                };
            else if (hours < 24)
                return {
                    text: `Expires in ${expirationTime}`,
                    styleObj: expiryPriority.moderate
                };
            else
                return {
                    text: `Expires in ${expirationTime}`,
                    styleObj: expiryPriority.least
                };
        } else {
            return {
                text: `Expired`,
                styleObj: expiryPriority.most
            };
        }
    };

    const { text, styleObj } = renderTime(expiry_time);
    return (
        <span
            className={classNames(expiresClass, is_mobile ? Styles.expires_mobile : Styles.expires_desktop)}
            style={{ backgroundColor: is_mobile ? "transparent" : styleObj.background, color: styleObj.text }}
        >
            {text}
        </span>
    );
};

export default expiryPill;
